'use client';
import React, { useState } from 'react';
import Head from 'next/head';
import Link from 'next/link';

 const sections = [

      {
        title: "Services",
        content: "Vilva Business provides IT and software development services, including but not limited to e-commerce solutions, SaaS platforms, and custom software development. Our services are subject to change, and we reserve the right to modify or discontinue any aspect of our services without notice."
      },
      {
        title: "User Responsibilities",
        content: "By using our services, you agree to:\n- Provide accurate and up-to-date information when registering or engaging with our services.\n- Comply with all applicable laws and regulations.\n- Use our services for lawful purposes only and not for any fraudulent, abusive, or otherwise illegal activities.\n- Keep your account information secure and notify us immediately of any unauthorized use."
      },
      {
        title: "Intellectual Property Rights",
        content: "All content, trademarks, and data on this site, including but not limited to software, text, graphics, and logos, are the property of Vilva Business and are protected by intellectual property laws. You may not reproduce, distribute, or create derivative works from our content without our express written permission."
      },
      {
        title: "Confidentiality",
        content: "Both parties agree to maintain the confidentiality of proprietary information disclosed during the course of business. Confidential information shall not be disclosed to third parties without prior consent from the disclosing party, except as required by law."
      },
      {
        title: "Limitation of Liability",
        content: "Vilva Business shall not be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with the use of our services. Our total liability to you for any claim arising from our services shall not exceed the amount paid by you for such services."
      },
      {
        title: "Indemnification",
        content: "You agree to indemnify and hold harmless Vilva Business, its affiliates, and employees from any claims, damages, losses, or expenses arising from your use of our services, your violation of these Terms and Conditions, or your infringement of any third-party rights."
      },
      {
        title: "Termination",
        content: "We reserve the right to terminate or suspend your access to our services at our sole discretion, without notice, for conduct that we believe violates these Terms and Conditions or is harmful to other users of our services, us, or third parties, or for any other reason."
      },
      {
        title: "Governing Law",
        content: "These Terms and Conditions are governed by and construed in accordance with the laws of India, without regard to its conflict of law principles. You agree to submit to the exclusive jurisdiction of the courts located in Bengaluru, India."
      },
      {
        title: "Amendments",
        content: "Vilva Business reserves the right to amend these Terms and Conditions at any time. Your continued use of our services after any changes to these terms constitutes your acceptance of the new Terms and Conditions."
      },
      {
        title: "Contact Information",
        content: "Vilva Business\nEmail: info@vilvabusiness.com\nPhone: +91 9176569459"
      }
    ];

const TermsAndConditions = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleSection = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>

      <div className=' bg-[linear-gradient(180deg,_#EEF3FF_0%,_#FFF_26.53%)]'>


      <div className="max-w-2xl mx-auto px-4 py-[50px] text-[#1f1f1f]">
        <h1 className="text-[color:var(--Dark-Color,#090D28)]  text-center mb-[40px] font-NeueMontreal text-[32px] md:text-[40px] not-italic font-normal leading-[120%]">Terms & Conditions</h1>
        <p className="text-[#373844] font-Schibsted_Grotesk mb-[40px] text-[14px] md:text-[16px] not-italic font-normal leading-[150%]">
Welcome to Vilva Business! These Terms and Conditions ("Terms") govern your use of our digital services, including e-commerce websites similar to Shopify and WooCommerce, and APIs (the "Services"). By accessing or using our Services, you agree to comply with and be bound by these Terms. If you do not agree with these Terms, please do not use our Services.
        </p>


        {sections.map((section, index) => (
          <div key={index}     className={`border-t py-[24px] ${index === sections.length - 1 ? 'border-b' : ''}`}>
            <div
              role="button"
              tabIndex={0}
              aria-expanded={openIndex === index}
              aria-controls={`terms-panel-${index}`}
              onClick={() => toggleSection(index)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleSection(index); } }}
              className="flex justify-between items-center cursor-pointer"
            >
              <h2 className="text-[color:var(--Dark-Color,#090D28)] font-Schibsted_Grotesk text-[20px] md:text-[24px] not-italic font-black leading-[100%]">{section.title}</h2>
              <span aria-hidden="true" className="flex w-[32px] h-[32px] p-[6px] justify-center items-center aspect-square rounded-[6px] bg-[#EFF4FF]">
                {openIndex === index ? <svg className={`transform transition-transform duration-300 ${
      openIndex !== index ? 'rotate-0' : 'rotate-180'
    }`} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M4.16602 10H15.8327" stroke="#195AFF" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
</svg> : <svg className={`transform transition-transform duration-300 ${
      openIndex === index ? 'rotate-90' : 'rotate-0'
    }`} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M4.16602 10H15.8327" stroke="#195AFF" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M10 4.16667V15.8333" stroke="#195AFF" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
</svg>}
              </span>
            </div>

            <div
              id={`terms-panel-${index}`}
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                openIndex === index ? 'max-h-[1000px] mt-2' : 'max-h-0'
              }`}
            >
              <p className="text-[#373844] font-Schibsted_Grotesk text-[14px] md:text-[16px] not-italic font-normal leading-[150%]">{section.content}</p>
            </div>
          </div>
        ))}


<div className='mt-[80px] flex items-center justify-center gap-[16px] flex-wrap'>
  <Link className="text-[color:var(--Main-colour,#195AFF)] font-Schibsted_Grotesk text-[14px] not-italic font-normal leading-[120%] !underline" href={'/privacy-policy'}>Privacy Policy</Link>
  <Link className="text-[color:var(--Main-colour,#195AFF)] font-Schibsted_Grotesk text-[14px] not-italic font-normal leading-[120%] !underline" href={'/terms-and-condition'}>Other Policies</Link>
  <Link className="text-[color:var(--Main-colour,#195AFF)] font-Schibsted_Grotesk text-[14px] not-italic font-normal leading-[120%] !underline" href={'/cookie-policy'}>Cookie Policy</Link>

</div>

        
      </div>

<div className='bg-[#01001E] py-[60px] md:py-[120px] flex items-center justify-center'>

<div>
  <h3 className="text-white font-NeueMontreal text-center text-[32px] md:text-[48px] not-italic font-normal leading-[120%]">Always <span className="text-transparent bg-[linear-gradient(90deg,_#15BDFF_20.57%,_#C05DF2_54.45%)] bg-clip-text font-NeueMontreal text-[32px] md:text-[48px] not-italic font-normal leading-[120%]"
>On Schedule </span>  always <span className="text-transparent mb-[16px] bg-[linear-gradient(90deg,_#15BDFF_20.57%,_#C05DF2_54.45%)] bg-clip-text font-NeueMontreal text-[32px] md:text-[48px] not-italic font-normal leading-[120%]"
>Reliable</span> </h3>

  <p className="text-[#DADAE4] text-center mb-[24px] font-Schibsted_Grotesk text-[16px] md:text-[18px] not-italic font-normal leading-[150%]">Our team ensures timely results without compromising quality</p>

  <Link className="rounded-[8px] w-fit bg-[var(--Main-colour,#195AFF)] mx-auto flex h-[48px] px-[32px] py-[16px] justify-center items-center text-white font-Schibsted_Grotesk text-[18px] not-italic font-normal leading-[120%]"
 href={'/book-demo'}> Book Free Demo </Link>
</div>
</div>

      </div>

    </>
  );
};

export default TermsAndConditions;
